import { memo } from 'react';
import { Mail, Phone } from 'lucide-react';
import { asString, hasField } from './helpers';

const InvestorContactDetails = memo(function InvestorContactDetails({
  investor,
  className = 'mb-4 text-sm text-gray-700',
  phoneClassName = 'flex items-center gap-2 mb-2',
  emailClassName = 'flex items-center gap-2',
}) {
  const phone = asString(investor?.phone).trim();
  const email = asString(investor?.email).trim();
  const showPhone = hasField(investor, 'phone') && phone;
  const showEmail = hasField(investor, 'email') && email;

  if (!showPhone && !showEmail) {
    return null;
  }

  return (
    <div className={className}>
      {showPhone && (
        <a href={`tel:${phone}`} className={phoneClassName}>
          <Phone size={16} aria-hidden="true" />
          <span className="truncate">{phone}</span>
        </a>
      )}
      {showEmail && (
        <a href={`mailto:${email}`} className={emailClassName}>
          <Mail size={16} aria-hidden="true" />
          <span className="truncate">{email}</span>
        </a>
      )}
    </div>
  );
});

export default InvestorContactDetails;
